import * as constants from 'helper/constants';
import { Link } from 'react-router-dom';
import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';

export default class Contact extends PureComponent {
  constructor(props) {
    super(props);

    this.user = this.props.user;
  }

  componentDidMount() {
    window.Intercom('boot', {
      app_id: constants.intercomAppId,
    });
  }

  componentWillUnmount() {
    window.Intercom('shutdown');
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col">
            <Link to="/" className="btn btn-outline-primary">
              {strings.back}
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <h6>{strings.myMimiAccount}</h6>
            <h2>{strings.contactUs.slice(0, -1)}</h2>
            <p>{strings.wedLoveToHearFromYou}</p>
            <p>{strings.ifYouHaveFeedback}</p>
            <p>{strings.correspondenceCare} <a href={strings.privacyPolicyLink} target="_blank" rel="noopener noreferrer">{strings.navPrivacyPolicy}</a>{'.'}</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/accountManagement/Contact.jsx